import { Component, Input, OnInit } from '@angular/core';
import { LoadingTextService } from './loading-text.service';

@Component({
    selector: 'app-loading-text',
    templateUrl: './loading-text.component.html',
    styleUrls: ['./loading-text.component.css'],
    standalone: false
})
export class LoadingTextComponent implements OnInit {

  @Input() showLoading: boolean = true;
  public message: string = '';

  constructor(public loadingTextService: LoadingTextService) {}

  ngOnInit() {
    this.message = this.loadingTextService.getMessage()
  }

}
